import { Address } from '../swagger'
import { extractedErrorObject, addressApi } from '../api/swagger'

export interface AddressValidationResult {
  success: boolean
  validAddresses?: Address[]
  error?: string
  shouldSelectAddress?: boolean
}

export interface GeocodeResult {
  success: boolean
  error?: string
  isDenied?: boolean
}

export const validateAddress = async (
  billingAddress: Address,
  isExactMatchRequired = true
): Promise<AddressValidationResult> => {
  try {
    const result = await addressApi.validateAddress({
      body: billingAddress,
      disableGeocoding: false,
    })

    if (result.length === 0) {
      return {
        success: false,
        error: 'Address could not be verified',
      }
    }

    if (isExactMatchRequired && result.length === 1) {
      const validatedAddress = result[0]
      const isExactMatch =
        validatedAddress.streetAddress1 === billingAddress.streetAddress1 &&
        (validatedAddress.streetAddress2 ?? '') ===
          (billingAddress.streetAddress2 ?? '') &&
        validatedAddress.city === billingAddress.city &&
        validatedAddress.state === billingAddress.state &&
        validatedAddress.countryCode === billingAddress.countryCode &&
        validatedAddress.zip === billingAddress.zip

      if (isExactMatch) {
        return {
          success: true,
          validAddresses: result,
        }
      }
    }

    return {
      success: true,
      validAddresses: result,
      shouldSelectAddress: true,
    }
  } catch (err) {
    const errorObject = (await extractedErrorObject(err)) ?? {
      code: 'UnknownError',
      message:
        (err as unknown as Error).message ??
        'Failed to validate address at this time.',
    }
    return {
      success: false,
      error: errorObject.message,
    }
  }
}

export const geocodeAddress = async (
  billingAddress: Address
): Promise<GeocodeResult> => {
  try {
    const result = await addressApi.validateAddress({
      body: billingAddress,
      disableAddressVerification: true,
    })

    if (result.length === 0) {
      return {
        success: false,
        isDenied: true,
      }
    }

    return {
      success: true,
    }
  } catch (err) {
    const errorObject = (await extractedErrorObject(err)) ?? {
      code: 'UnknownError',
      message:
        (err as unknown as Error).message ??
        'Failed to validate address at this time.',
    }
    return {
      success: false,
      error: errorObject.message,
    }
  }
}
